const PROFESSION_OPTIONS = [
    "",
    "Accountant",
    "Actor",
    "Actuary",
    "Adhesive Bonding Machine Tender",
    "Adjudicator",
    "Administrative Assistant",
    "Administrative Services Manager",
    "Adult Education Teacher",
    "Advertising Manager",
    "Advertising Sales Agent",
    "Aerobics Instructor",
    "Aerospace Engineer",
    "Aerospace Engineering Technician",
    "Agent",
    "Agricultural Engineer",
    "Agricultural Equipment Operator",
    "Agricultural Grader",
    "Agricultural Inspector",
    "Agricultural Manager",
    "Agricultural Sciences Teacher",
    "Agricultural Sorter",
    "Agricultural Technician",
    "Agricultural Worker",
    "Air Conditioning Installer",
    "Air Conditioning Mechanic",
    "Air Traffic Controller",
    "Aircraft Cargo Handling Supervisor",
    "Aircraft Mechanic",
    "Aircraft Service Technician",
    "Airline Copilot",
    "Airline Pilot",
    "Ambulance Dispatcher",
    "Ambulance Driver",
    "Amusement Machine Servicer",
    "Anesthesiologist",
    "Animal Breeder",
    "Animal Control Worker",
    "Animal Scientist",
    "Animal Trainer",
    "Animator",
    "Answering Service Operator",
    "Anthropologist",
    "Apparel Patternmaker",
    "Apparel Worker",
    "Arbitrator",
    "Archeologist",
    "Architect",
    "Architectural Drafter",
    "Architectural Manager",
    "Archivist",
    "Art Director",
    "Art Teacher",
    "Artist",
    "Assembler",
    "Astronomer",
    "Athlete",
    "Athletic Trainer",
    "Atm Machine Repairer",
    "Atmospheric Scientist",
    "Attendant",
    "Audio And Video Equipment Technician",
    "Audio-Visual And Multimedia Collections Specialist",
    "Audiologist",
    "Auditor",
    "Author",
    "Auto Damage Insurance Appraiser",
    "Automotive And Watercraft Service Attendant",
    "Automotive Glass Installer",
    "Automotive Mechanic",
    "Avionics Technician",
"Back-End Developer",
    "Baggage Porter",
    "Bailiff",
    "Baker",
    "Barback",
    "Barber",
    "Bartender",
    "Basic Education Teacher",
    "Behavioral Disorder Counselor",
    "Bellhop",
    "Bench Carpenter",
    "Bicycle Repairer",
    "Bill And Account Collector",
    "Billing And Posting Clerk",
    "Biochemist",
    "Biological Technician",
    "Biomedical Engineer",
    "Biophysicist",
    "Blaster",
    "Blending Machine Operator",
    "Blockmason",
    "Boiler Operator",
    "Boilermaker",
    "Bookkeeper",
    "Boring Machine Tool Tender",
    "Brazer",
    "Brickmason",
    "Bridge And Lock Tender",
    "Broadcast News Analyst",
    "Broadcast Technician",
    "Brokerage Clerk",
    "Budget Analyst",
    "Building Inspector",
    "Bus Mechanic",
    "Butcher",
    "Buyer",
    "Cabinetmaker",
    "Cafeteria Attendant",
    "Cafeteria Cook",
    "Camera Operator",
    "Camera Repairer",
    "Cardiovascular Technician",
    "Cargo Agent",
    "Carpenter",
    "Carpet Installer",
    "Cartographer",
    "Cashier",
    "Caster",
    "Ceiling Tile Installer",
    "Cellular Equipment Installer",
    "Cement Mason",
    "Channeling Machine Operator",
    "Chauffeur",
    "Checker",
    "Chef",
    "Chemical Engineer",
    "Chemical Plant Operator",
    "Chemist",
    "Chemistry Teacher",
    "Chief Executive",
    "Child Social Worker",
    "Childcare Worker",
    "Chiropractor",
    "Choreographer",
    "Civil Drafter",
    "Civil Engineer",
    "Civil Engineering Technician",
    "Claims Adjuster",
    "Claims Examiner",
    "Claims Investigator",
    "Cleaner",
    "Clinical Laboratory Technician",
    "Clinical Laboratory Technologist",
    "Clinical Psychologist",
    "Coating Worker",
    "Coatroom Attendant",
    "Coil Finisher",
    "Coil Taper",
    "Coil Winder",
    "Coin Machine Servicer",
    "Commercial Diver",
    "Commercial Pilot",
    "Commodities Sales Agent",
    "Communications Equipment Operator",
    "Communications Teacher",
    "Community Association Manager",
    "Community Service Manager",
    "Compensation And Benefits Manager",
    "Compliance Officer",
    "Composer",
    "Computer Hardware Engineer",
    "Computer Network Architect",
    "Computer Operator",
    "Computer Programmer",
    "Computer Science Teacher",
    "Computer Support Specialist",
    "Computer Systems Administrator",
    "Computer Systems Analyst",
    "Concierge",
    "Conciliator",
    "Concrete Finisher",
    "Conservation Science Teacher",
    "Conservation Scientist",
    "Conservation Worker",
    "Conservator",
    "Construction Inspector",
    "Construction Manager",
    "Construction Painter",
    "Construction Worker",
    "Continuous Mining Machine Operator",
    "Convention Planner",
    "Conveyor Operator",
    "Cook",
    "Cooling Equipment Operator",
    "Copy Marker",
    "Correctional Officer",
    "Correctional Treatment Specialist",
    "Correspondence Clerk",
    "Correspondent",
    "Cosmetologist",
    "Cost Estimator",
    "Costume Attendant",
    "Counseling Psychologist",
    "Counselor",
    "Courier",
    "Court Reporter",
    "Craft Artist",
    "Crane Operator",
    "Credit Analyst",
    "Credit Checker",
    "Credit Counselor",
    "Criminal Investigator",
    "Criminal Justice Teacher",
    "Crossing Guard",
    "Curator",
    "Custom Sewer",
    "Customer Service Representative",
    "Cutter",
    "Cutting Machine Operator",
    "Dancer",
    "Data Entry Keyer",
    "Database Administrator",
    "Decorating Worker",
    "Delivery Services Driver",
    "Demonstrator",
    "Dental Assistant",
    "Dental Hygienist",
    "Dental Laboratory Technician",
    "Dentist",
"Dermatologist",
    "Derrick Operator",
    "Designer",
    "Desktop Publisher",
    "Detective",
"Developer",
    "Diagnostic Medical Sonographer",
    "Die Maker",
    "Diesel Engine Specialist",
    "Dietetic Technician",
    "Dietitian",
    "Dinkey Operator",
    "Director",
    "Dishwasher",
    "Dispatcher",
"Dj",
"Doctor",
    "Door-To-Door Sales Worker",
    "Drafter",
    "Dragline Operator",
    "Drama Teacher",
    "Dredge Operator",
    "Dressing Room Attendant",
    "Dressmaker",
    "Drier Operator",
    "Drilling Machine Tool Operator",
    "Dry-Cleaning Worker",
    "Drywall Installer",
    "Dyeing Machine Operator",
    "Earth Driller",
    "Economics Teacher",
    "Economist",
    "Editor",
    "Education Administrator",
    "Electric Motor Repairer",
    "Electrical Electronics Drafter",
    "Electrical Engineer",
    "Electrical Equipment Assembler",
    "Electrical Installer",
    "Electrical Power-Line Installer",
    "Electrician",
    "Electro-Mechanical Technician",
    "Elementary School Teacher",
    "Elevator Installer",
    "Elevator Repairer",
    "Embalmer",
    "Emergency Management Director",
    "Emergency Medical Technician",
    "Engine Assembler",
    "Engineer",
    "Engineering Manager",
    "Engineering Teacher",
    "English Language Teacher",
    "Engraver",
    "Entertainment Attendant",
    "Environmental Engineer",
    "Environmental Science Teacher",
    "Environmental Scientist",
    "Epidemiologist",
    "Escort",
    "Etcher",
    "Event Planner",
    "Excavating Operator",
    "Executive Administrative Assistant",
    "Executive Secretary",
    "Exhibit Designer",
    "Expediting Clerk",
    "Explosives Worker",
    "Extraction Worker",
    "Fabric Mender",
    "Fabric Patternmaker",
    "Fabricator",
    "Faller",
    "Family Practitioner",
    "Family Social Worker",
    "Family Therapist",
    "Farm Advisor",
    "Farm Equipment Mechanic",
    "Farm Labor Contractor",
    "Farmer",
    "Farmworker",
    "Fashion Designer",
    "Fast Food Cook",
    "Fence Erector",
    "Fiberglass Fabricator",
    "Fiberglass Laminator",
    "File Clerk",
    "Filling Machine Operator",
    "Film And Video Editor",
    "Financial Analyst",
    "Financial Examiner",
    "Financial Manager",
    "Financial Services Sales Agent",
    "Fine Artist",
    "Fire Alarm System Installer",
    "Fire Dispatcher",
    "Fire Inspector",
    "Fire Investigator",
    "Firefighter",
    "Fish And Game Warden",
    "Fish Cutter",
    "Fish Trimmer",
    "Fisher",
    "Fitness Studies Teacher",
    "Fitness Trainer",
    "Flight Attendant",
    "Floor Finisher",
    "Floor Layer",
    "Floor Sander",
    "Floral Designer",
    "Food Batchmaker",
    "Food Cooking Machine Operator",
    "Food Preparation Worker",
    "Food Science Technician",
    "Food Scientist",
    "Food Server",
    "Food Service Manager",
    "Food Technologist",
    "Foreign Language Teacher",
    "Foreign Literature Teacher",
    "Forensic Science Technician",
    "Forest Fire Inspector",
    "Forest Fire Prevention Specialist",
    "Forest Worker",
    "Forester",
    "Forestry Teacher",
    "Forging Machine Setter",
    "Foundry Coremaker",
    "Freight Agent",
    "Freight Mover",
"Front-End Developer",
    "Fundraising Manager",
    "Funeral Attendant",
    "Funeral Director",
    "Funeral Service Manager",
    "Furnace Operator",
    "Furnishings Worker",
    "Furniture Finisher",
    "Gaming Booth Cashier",
    "Gaming Cage Worker",
    "Gaming Change Person",
    "Gaming Dealer",
    "Gaming Investigator",
    "Gaming Manager",
    "Gaming Surveillance Officer",
    "Garment Mender",
    "Garment Presser",
    "Gas Compressor",
    "Gas Plant Operator",
    "Gas Pumping Station Operator",
    "General Manager",
    "General Practitioner",
    "Geographer",
    "Geography Teacher",
    "Geological Engineer",
    "Geological Technician",
    "Geoscientist",
    "Glazier",
    "Government Program Eligibility Interviewer",
    "Graduate Teaching Assistant",
    "Graphic Designer",
    "Groundskeeper",
    "Groundskeeping Worker",
    "Gynecologist",
    "Hairdresser",
    "Hairstylist",
    "Hand Grinding Worker",
    "Hand Laborer",
    "Hand Packager",
    "Hand Packer",
    "Hand Polishing Worker",
    "Hand Sewer",
    "Hazardous Materials Removal Worker",
    "Head Cook",
    "Health And Safety Engineer",
    "Health Educator",
    "Health Information Technician",
    "Health Services Manager",
    "Health Specialties Teacher",
    "Healthcare Social Worker",
    "Hearing Officer",
    "Heat Treating Equipment Setter",
    "Heating Installer",
    "Heating Mechanic",
    "Heavy Truck Driver",
    "Highway Maintenance Worker",
    "Historian",
    "History Teacher",
    "Hoist And Winch Operator",
    "Home Appliance Repairer",
    "Home Economics Teacher",
    "Home Entertainment Installer",
    "Home Health Aide",
    "Home Management Advisor",
    "Host",
    "Hostess",
    "Hostler",
    "Hotel Desk Clerk",
    "Housekeeping Cleaner",
    "Human Resources Assistant",
    "Human Resources Manager",
    "Human Service Assistant",
    "Hunter",
    "Hydrologist",
    "Illustrator",
    "Industrial Designer",
    "Industrial Engineer",
    "Industrial Engineering Technician",
    "Industrial Machinery Mechanic",
    "Industrial Production Manager",
    "Industrial Truck Operator",
    "Industrial-Organizational Psychologist",
    "Information Clerk",
    "Information Research Scientist",
    "Information Security Analyst",
    "Information Systems Manager",
    "Inspector",
    "Instructional Coordinator",
    "Instructor",
    "Insulation Worker",
    "Insurance Claims Clerk",
    "Insurance Sales Agent",
    "Insurance Underwriter",
    "Intercity Bus Driver",
    "Interior Designer",
    "Internist",
    "Interpreter",
    "Interviewer",
    "Investigator",
    "Jailer",
    "Janitor",
    "Jeweler",
    "Judge",
    "Judicial Law Clerk",
    "Kettle Operator",
    "Kiln Operator",
    "Kindergarten Teacher",
    "Laboratory Animal Caretaker",
    "Landscape Architect",
    "Landscaping Worker",
    "Lathe Setter",
    "Laundry Worker",
    "Law Enforcement Teacher",
    "Law Teacher",
    "Lawyer",
    "Layout Worker",
    "Leather Worker",
    "Legal Assistant",
    "Legal Secretary",
    "Legislator",
    "Librarian",
    "Library Assistant",
    "Library Science Teacher",
    "Library Technician",
    "Licensed Practical Nurse",
    "Licensed Vocational Nurse",
    "Life Scientist",
    "Lifeguard",
    "Light Truck Driver",
    "Line Installer",
    "Literacy Teacher",
    "Literature Teacher",
    "Loading Machine Operator",
    "Loan Clerk",
    "Loan Interviewer",
    "Loan Officer",
    "Lobby Attendant",
    "Locker Room Attendant",
    "Locksmith",
    "Locomotive Engineer",
    "Locomotive Firer",
    "Lodging Manager",
    "Log Grader",
    "Logging Equipment Operator",
    "Logistician",
    "Machine Feeder",
    "Machinist",
    "Magistrate Judge",
    "Magistrate",
    "Maid",
    "Mail Clerk",
    "Mail Machine Operator",
    "Mail Superintendent",
    "Maintenance Painter",
    "Maintenance Worker",
    "Makeup Artist",
    "Management Analyst",
    "Manicurist",
    "Manufactured Building Installer",
    "Mapping Technician",
    "Marble Setter",
    "Marine Engineer",
    "Marine Oiler",
    "Market Research Analyst",
    "Marketing Manager",
    "Marketing Specialist",
    "Marriage Therapist",
    "Massage Therapist",
    "Material Mover",
    "Materials Engineer",
    "Materials Scientist",
    "Mathematical Science Teacher",
    "Mathematical Technician",
    "Mathematician",
    "Maxillofacial Surgeon",
    "Measurer",
    "Meat Cutter",
    "Meat Packer",
    "Meat Trimmer",
    "Mechanical Door Repairer",
    "Mechanical Drafter",
    "Mechanical Engineer",
    "Mechanical Engineering Technician",
    "Mediator",
    "Medical Appliance Technician",
    "Medical Assistant",
    "Medical Equipment Preparer",
    "Medical Equipment Repairer",
    "Medical Laboratory Technician",
    "Medical Laboratory Technologist",
    "Medical Records Technician",
    "Medical Scientist",
    "Medical Secretary",
    "Medical Services Manager",
    "Medical Transcriptionist",
    "Meeting Planner",
    "Mental Health Counselor",
    "Mental Health Social Worker",
    "Merchandise Displayer",
    "Messenger",
    "Metal Caster",
    "Metal Patternmaker",
    "Metal Pickling Operator",
    "Metal Pourer",
    "Metal Worker",
    "Metal-Refining Furnace Operator",
    "Metal-Refining Furnace Tender",
    "Meter Reader",
    "Microbiologist",
    "Middle School Teacher",
    "Milling Machine Setter",
    "Millwright",
    "Mine Cutting Machine Operator",
    "Mine Shuttle Car Operator",
    "Mining Engineer",
    "Mining Safety Engineer",
    "Mining Safety Inspector",
    "Mining Service Unit Operator",
    "Mixing Machine Setter",
    "Mobile Heavy Equipment Mechanic",
    "Mobile Home Installer",
    "Model Maker",
    "Model",
    "Molder",
    "Mortician",
    "Motel Desk Clerk",
    "Motion Picture Projectionist",
    "Motorboat Mechanic",
    "Motorboat Operator",
    "Motorboat Service Technician",
    "Motorcycle Mechanic",
"Movers",
    "Multimedia Artist",
    "Museum Technician",
    "Music Director",
    "Music Teacher",
    "Musical Instrument Repairer",
    "Musician",
    "Natural Sciences Manager",
    "Naval Architect",
    "Network Systems Administrator",
    "New Accounts Clerk",
    "News Vendor",
    "Nonfarm Animal Caretaker",
    "Nuclear Engineer",
    "Nuclear Medicine Technologist",
    "Nuclear Power Reactor Operator",
    "Nuclear Technician",
    "Nursing Aide",
    "Nursing Instructor",
    "Nursing Teacher",
    "Nutritionist",
    "Obstetrician",
    "Occupational Health And Safety Specialist",
    "Occupational Health And Safety Technician",
    "Occupational Therapist",
    "Occupational Therapy Aide",
    "Occupational Therapy Assistant",
    "Offbearer",
    "Office Clerk",
    "Office Machine Operator",
    "Operating Engineer",
    "Operations Manager",
    "Operations Research Analyst",
    "Ophthalmic Laboratory Technician",
    "Optician",
    "Optometrist",
    "Oral Surgeon",
    "Order Clerk",
    "Order Filler",
    "Orderly",
    "Ordnance Handling Expert",
    "Orthodontist",
    "Orthotist",
    "Outdoor Power Equipment Mechanic",
    "Oven Operator",
    "Packaging Machine Operator",
    "Painter ",
    "Painting Worker",
    "Paper Goods Machine Setter",
    "Paperhanger",
    "Paralegal",
    "Paramedic",
    "Parking Enforcement Worker",
    "Parking Lot Attendant",
    "Parts Salesperson",
    "Paving Equipment Operator",
    "Payroll Clerk",
    "Pediatrician",
    "Pedicurist",
    "Personal Care Aide",
    "Personal Chef",
    "Personal Financial Advisor",
"Personal Trainer",
    "Pest Control Worker",
    "Pesticide Applicator",
    "Pesticide Handler",
    "Pesticide Sprayer",
    "Petroleum Engineer",
    "Petroleum Gauger",
    "Petroleum Pump System Operator",
    "Petroleum Refinery Operator",
    "Petroleum Technician",
    "Pharmacist",
    "Pharmacy Aide",
    "Pharmacy Technician",
    "Philosophy Teacher",
    "Photogrammetrist",
    "Photographer",
    "Photographic Process Worker",
    "Photographic Processing Machine Operator",
    "Physical Therapist Aide",
    "Physical Therapist Assistant",
    "Physical Therapist",
    "Physician Assistant",
    "Physician",
    "Physicist",
    "Physics Teacher",
    "Pile-Driver Operator",
    "Pipefitter",
    "Pipelayer",
    "Planing Machine Operator",
    "Planning Clerk",
    "Plant Operator",
    "Plant Scientist",
    "Plasterer",
    "Plastic Patternmaker",
    "Plastic Worker",
    "Plumber",
    "Podiatrist",
    "Police Dispatcher",
    "Police Officer",
    "Policy Processing Clerk",
    "Political Science Teacher",
    "Political Scientist",
    "Postal Service Clerk",
    "Postal Service Mail Carrier",
    "Postal Service Mail Processing Machine Operator",
    "Postal Service Mail Processor",
    "Postal Service Mail Sorter",
    "Postmaster",
    "Postsecondary Teacher",
    "Poultry Cutter",
    "Poultry Trimmer",
    "Power Dispatcher",
    "Power Distributor",
    "Power Plant Operator",
    "Power Tool Repairer",
    "Precious Stone Worker",
    "Precision Instrument Repairer",
    "Prepress Technician",
    "Preschool Teacher",
    "Priest",
    "Print Binding Worker",
    "Printing Press Operator",
    "Private Detective",
    "Probation Officer",
    "Procurement Clerk",
    "Producer",
    "Product Promoter",
"Product Manager",
    "Production Clerk",
    "Production Occupation",
    "Proofreader",
    "Property Manager",
    "Prosthetist",
    "Prosthodontist",
    "Psychiatric Aide",
    "Psychiatric Technician",
    "Psychiatrist",
    "Psychologist",
    "Psychology Teacher",
    "Public Relations Manager",
    "Public Relations Specialist",
    "Pump Operator",
    "Purchasing Agent",
    "Purchasing Manager",
    "Radiation Therapist",
    "Radio Announcer",
    "Radio Equipment Installer",
    "Radio Operator",
    "Radiologic Technician",
    "Radiologic Technologist",
    "Rail Car Repairer",
    "Rail Transportation Worker",
    "Rail Yard Engineer",
    "Rail-Track Laying Equipment Operator",
    "Railroad Brake Operator",
    "Railroad Conductor",
    "Railroad Police",
    "Rancher",
    "Real Estate Appraiser",
    "Real Estate Broker",
    "Real Estate Manager",
    "Real Estate Sales Agent",
    "Receiving Clerk",
    "Receptionist",
    "Record Clerk",
    "Recreation Teacher",
    "Recreation Worker",
    "Recreational Therapist",
    "Recreational Vehicle Service Technician",
    "Recyclable Material Collector",
    "Referee",
    "Refractory Materials Repairer",
    "Refrigeration Installer",
    "Refrigeration Mechanic",
    "Refuse Collector",
    "Regional Planner",
    "Registered Nurse",
    "Rehabilitation Counselor",
    "Reinforcing Iron Worker",
    "Reinforcing Rebar Worker",
    "Religion Teacher",
    "Religious Activities Director",
    "Religious Worker",
    "Rental Clerk",
    "Repair Worker",
    "Reporter",
    "Residential Advisor",
    "Resort Desk Clerk",
    "Respiratory Therapist",
    "Respiratory Therapy Technician",
    "Retail Buyer",
    "Retail Salesperson",
    "Revenue Agent",
    "Rigger",
    "Rock Splitter",
    "Rolling Machine Tender",
    "Roof Bolter",
    "Roofer",
    "Rotary Drill Operator",
    "Roustabout",
    "Safe Repairer",
    "Sailor",
    "Sales Engineer",
    "Sales Manager",
    "Sales Representative",
    "Sampler",
    "Sawing Machine Operator",
    "Scaler",
    "School Bus Driver",
    "School Psychologist",
    "School Social Worker",
    "Scout Leader",
    "Sculptor",
    "Secondary Education Teacher",
    "Secondary School Teacher",
    "Secretary",
    "Securities Sales Agent",
    "Security Guard",
    "Security System Installer",
    "Segmental Paver",
    "Self-Enrichment Education Teacher",
    "Semiconductor Processor",
    "Septic Tank Servicer",
    "Set Designer",
    "Sewer Pipe Cleaner",
    "Sewing Machine Operator",
    "Shampooer",
    "Shaper",
    "Sheet Metal Worker",
    "Sheriff's Patrol Officer",
    "Ship Captain",
    "Ship Engineer",
    "Ship Loader",
    "Shipmate",
    "Shipping Clerk",
    "Shoe Machine Operator",
    "Shoe Worker",
    "Short Order Cook",
    "Signal Operator",
    "Signal Repairer",
    "Singer",
    "Ski Patrol",
    "Skincare Specialist",
    "Slaughterer",
    "Slicing Machine Tender",
    "Slot Supervisor",
    "Social Science Research Assistant",
    "Social Sciences Teacher",
    "Social Scientist",
    "Social Service Assistant",
    "Social Service Manager",
    "Social Work Teacher",
    "Social Worker",
    "Sociologist",
    "Sociology Teacher",
    "Software Developer",
    "Software Engineer",
    "Soil Scientist",
    "Solderer",
    "Sorter",
    "Sound Engineering Technician",
    "Space Scientist",
    "Special Education Teacher",
    "Speech-Language Pathologist",
    "Sports Book Runner",
    "Sports Entertainer",
    "Sports Performer",
    "Stationary Engineer",
    "Statistical Assistant",
    "Statistician",
    "Steamfitter",
    "Stock Clerk",
    "Stock Mover",
    "Stonemason",
    "Street Vendor",
    "Streetcar Operator",
    "Structural Iron Worker",
    "Structural Metal Fabricator",
    "Structural Metal Fitter",
    "Structural Steel Worker",
    "Stucco Mason",
    "Substance Abuse Counselor",
    "Substance Abuse Social Worker",
    "Subway Operator",
    "Surfacing Equipment Operator",
    "Surgeon",
    "Surgical Technologist",
    "Survey Researcher",
    "Surveying Technician",
    "Surveyor",
    "Switch Operator",
    "Switchboard Operator",
    "Tailor",
    "Tamping Equipment Operator",
    "Tank Car Loader",
    "Taper",
    "Tax Collector",
    "Tax Examiner",
    "Tax Preparer",
    "Taxi Driver",
    "Teacher Assistant",
    "Teacher",
    "Team Assembler",
    "Technical Writer",
    "Telecommunications Equipment Installer",
    "Telemarketer",
    "Telephone Operator",
    "Television Announcer",
    "Teller",
    "Terrazzo Finisher",
    "Terrazzo Worker",
    "Tester",
    "Textile Bleaching Operator",
    "Textile Cutting Machine Setter",
    "Textile Knitting Machine Setter",
    "Textile Presser",
    "Textile Worker",
    "Therapist",
    "Ticket Agent",
    "Ticket Taker",
    "Tile Setter",
    "Timekeeping Clerk",
    "Timing Device Assembler",
    "Tire Builder",
    "Tire Changer",
    "Tire Repairer",
    "Title Abstractor",
    "Title Examiner",
    "Title Searcher",
    "Tobacco Roasting Machine Operator",
    "Tool Filer",
    "Tool Grinder",
    "Tool Maker",
    "Tool Sharpener",
    "Tour Guide",
    "Tower Equipment Installer",
    "Tower Operator",
    "Track Switch Repairer",
    "Tractor Operator",
    "Tractor-Trailer Truck Driver",
    "Traffic Clerk",
    "Traffic Technician",
    "Training And Development Manager",
    "Training And Development Specialist",
    "Transit Police",
    "Translator",
    "Transportation Equipment Painter",
    "Transportation Inspector",
    "Transportation Security Screener",
    "Transportation Worker",
    "Trapper",
    "Travel Agent",
    "Travel Clerk",
    "Travel Guide",
    "Tree Pruner",
    "Tree Trimmer",
    "Trimmer",
    "Truck Loader",
    "Truck Mechanic",
    "Tuner",
    "Turning Machine Tool Operator",
"Tutor",
    "Typist",
    "Umpire",
    "Undertaker",
    "Upholsterer",
    "Urban Planner",
    "Usher",
"Ux Designer",
    "Valve Installer",
    "Vending Machine Servicer",
    "Veterinarian",
    "Veterinary Assistant",
    "Veterinary Technician",
    "Vocational Counselor",
    "Vocational Education Teacher",
    "Waiter",
    "Waitress",
    "Watch Repairer",
    "Water Treatment Plant Operator",
    "Weaving Machine Setter",
    "Web Developer",
    "Weigher",
    "Welder",
    "Wellhead Pumper",
    "Wholesale Buyer",
    "Wildlife Biologist",
    "Window Trimmer",
    "Wood Patternmaker",
    "Woodworker",
    "Word Processor",
    "Writer",
    "Yardmaster",
    "Zoologist"
]


export default PROFESSION_OPTIONS